import styled from 'styled-components';

export const TeamsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;

  @media (max-width: 730px) {
    overflow-x: auto;
    margin: 0 10px;
  }
`;

export const TeamsTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
  margin-right: 23vw;

  @media (max-width: 730px) {
    display: none;
  }
`;

export const ButtonWrapper = styled.div`
  margin: 5px;
  &:last-of-type {
    margin-right: 0;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
